// extracted by mini-css-extract-plugin
export var alertIcon = "_ui-0";